import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './ThreeNavGlass.css';

const TwoNavGlass = ({
  activeTab,
  onHomeClick,
  onVoiceModeClick
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Determine active tab based on current route if not explicitly provided
  const getCurrentTab = () => {
    if (activeTab) return activeTab;
    
    const path = location.pathname;
    if (path === '/') return 'voicemode';
    if (path === '/voice-mode') return 'voicemode';
    // Default to chatmode for other paths
    return 'voicemode';
  };

  const [selectedTab, setSelectedTab] = useState(getCurrentTab());
  const [isAnimating, setIsAnimating] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  // Update selected tab when location changes
  useEffect(() => {
    setSelectedTab(getCurrentTab());
  }, [location.pathname, activeTab]);

  const handleTabClick = (tab, callback, route) => {
    if (tab !== selectedTab && !isAnimating) {
      setIsAnimating(true);
      setSelectedTab(tab);
      
      setTimeout(async () => {
        setIsAnimating(false);
        
        // Navigate to route if provided
        if (route) {
          navigate(route);
        }
        
        // Call callback if provided
        if (callback) {
          callback();
        }
      }, 400);
    }
  };

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isSmallScreen = screenWidth < 640;

  return (
    <div className={`glassmorphism-nav-container two-tab ${isSmallScreen ? 'mobile' : ''}`} data-active={selectedTab}>
      
      <div className="tnv-nav-slider-indicator" />
      <div
        className={`tnv-nav-glass-tab ${selectedTab === 'voicemode' ? 'active' : ''} ${isAnimating && selectedTab !== 'chatmode' ? 'animating' : ''}`}
        onClick={() => handleTabClick('voicemode', onVoiceModeClick, '/')}
      >
        <div className="tnv-three-nav-glass-icon">
        </div>
        <span className="tnv-three-nav-glass-text">Chat Mode</span>
      </div>
      <div
        className={`tnv-nav-glass-tab ${selectedTab === 'home' ? 'active' : ''} ${isAnimating && selectedTab !== 'home' ? 'animating' : ''}`}
        onClick={() => handleTabClick('home', onHomeClick, '/voice-mode')}
      >
        <div className="tnv-nav-icon">
        </div>
        <span className="nav-text">Voice Mode</span>
      </div>


    </div>
  );
};

export default TwoNavGlass;